import { Pagination } from 'antd';
import React from 'react';
import Wrap from './styles';

type Props = {
  onChangePage?: any;
  totalItems?: number;
  page?: number;
  per_page?: number;
};

const PaginationCustomize = ({ onChangePage, totalItems, page, per_page }: Props) => {
  const onChange = (pageNumber: number) => {
    onChangePage(pageNumber);
  };

  const rowData = () => {
    if (totalItems) {
      if (page) {
        return (per_page ?? 20) * page > totalItems ? totalItems : (per_page ?? 20) * page;
      }
    }
    return '';
  };

  return (
    <Wrap>
      <div className="d-flex">
        <p className="text mb-0">{totalItems?.toLocaleString() || 0}件中</p>
        <p className="mb-0">
          {page && (per_page ?? 20) * page - (per_page ? per_page - 1 : 19)}〜{rowData()}
          件表示
        </p>
      </div>
      <Pagination
        className="pagination"
        size="small"
        defaultCurrent={1}
        current={page}
        total={totalItems}
        onChange={onChange}
        pageSize={per_page ?? 20}
        showSizeChanger={false}
      />
    </Wrap>
  );
};

export default PaginationCustomize;
